<section class="py-8 lg:py-12 3xl:py-16">
  <div class="px-[4%] sm:px-[9.3%] text-dark-gray2">
    <div class="flex items-center justify-between mb-6 3xl:mb-8">
      <h2
        class="text-3xl sm:text-4xl 3xl:text-5xl lg-leading-[40px] 3xl:leading-[57.6px] font-semibold 3xl:font-bold text-dark-gray2">
        Services</h2>
      <div class="flex items-center gap-4 3xl:gap-6">
        <app-button size="medium" [routerLink]="'/services'" heading="All services"
          icon="assets/shared/r-arrow.svg"></app-button>
        <div [className]="progress.abs == 0 ? 'pointer-events-none opacity-[0.6]':''">
          <app-button size="medium" (click)="prevSlide()" icon="assets/shared/l-arrow.svg"></app-button>
        </div>
        <div [className]="progress.abs == progress.maxIdx ? 'pointer-events-none opacity-[0.6]':''">
          <app-button size="medium" (click)="nextSlide()" icon="assets/shared/r-arrow.svg"></app-button>
        </div>
      </div>
    </div>
    <p class="text-base 3xl:text-lg text-dark-gray1 max-w-xl 3xl:max-w-2xl mb-8 lg:mb-12 3xl:mb-16">With complete,
      in-house expertise, we provide flexible, customized support— whether you’re starting from a concept or
      refining a product for the market.</p>
  </div>
  <div class="pl-[4%] sm:pl-[9.3%]">
    <div class="keen-slider" #sliderRef>
      <div class="keen-slider__slide " *ngFor="let category of serviceCategories">
        <a class="cursor-pointer block relative group overflow-y-hidden no-scrollbar h-[23rem] 3xl:h-[29rem] hover_div w-full mx-auto"
          [routerLink]="category.link">
          <div class="p-6 3xl:p-8 mb-7 border border-light-gray1 bg-card-gray rounded-md 3xl:rounded-lg">
            <div class="flex flex-col items-center">
              <img height="140" width="256" loading="lazy" class="hover_img w-full h-auto rounded-md 3xl:rounded-lg mb-6 3xl:mb-8" [src]="category.imgUrl" alt="{{category.name}}">
              <div class="h-[9rem] 3xl:h-[12.5rem]">
                <h3
                  class="text-dark-gray2 text-xl xl:text-base 2xl:text-xl 3xl:text-2xl font-semibold 3xl:font-bold mb-4 3xl:mb-5">
                  {{ category.name }}</h3>
                <p class="text-dark-gray2 text-xs 3xl:text-base">{{ category.desc }}</p>
              </div>
            </div>
          </div>

          <button
            class="text-xs 3xl:text-base flex items-center justify-between font-medium 3xl:font-bold bg-dark-gray1 w-full px-4 3xl:px-5 py-[6px] 3xl:py-2 text-white rounded-md 3xl:rounded-lg duration-500 ease-in-out">
            Learn more
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"
              class="bi bi-arrow-right-short" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
            </svg>
          </button>
        </a>

      </div>
    </div>
  </div>
</section>